import React from 'react';

const FlightDataTaskSummary = ({ date, flightNumber, from, to }) => {
  if (!date || !flightNumber || !from || !to) return null;

  return (
    <div className="flight-data-task-summary" aria-label="Completed flight data">
      <div className="flight-data-task-summary-field">
        <span>Flight Date:</span>
        <strong>{date}</strong>
      </div>
      <div className="flight-data-task-summary-field">
        <span>Flight Number:</span>
        <strong>{flightNumber}</strong>
      </div>
      <div className="flight-data-task-summary-field">
        <span>From - To:</span>
        <strong>{from} - {to}</strong>
      </div>
    </div>
  );
};

export default FlightDataTaskSummary;
